import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const LINKS = [
  {
    id: "synth",
    href: "/capital",
    labelFr: "Synthèse",
    labelEn: "Synthesis",
    isActive: (p) => p.startsWith("/capital"),
  },
  {
    id: "leaders",
    href: "/",
    labelFr: "Leaders du Marché",
    labelEn: "Market Leaders",
    isActive: (p) => p === "/",
  },
  {
    id: "flow",
    href: "/marketflow",
    labelFr: "Flux de Marché",
    labelEn: "Market Flow",
    isActive: (p) => p === "/marketflow" || p.startsWith("/marketflow/"),
  },
];

const SUBNAV_CSS = `
.mps-subnav-page{
  max-width:1600px;margin:0 auto;padding:14px 32px 0;
  display:flex;flex-wrap:wrap;gap:8px 24px;align-items:center;
}
.mps-subnav-page .mps-link{
  font-size:14px;font-weight:900;color:rgba(36,48,40,.55);
  cursor:pointer;padding:6px 0;position:relative;transition:color .15s;
  background:none;border:none;font-family:inherit;
}
.mps-subnav-page .mps-link:hover{color:#243028;}
.mps-subnav-page .mps-link.active{color:#243028;}
.mps-subnav-page .mps-link.active::after{
  content:'';position:absolute;bottom:0;left:0;right:0;height:3px;
  background:linear-gradient(90deg,#b59a5b,#d4b87a);border-radius:2px 2px 0 0;
}
@media(max-width:1000px){
  .mps-subnav-page{padding:12px 18px 0;gap:6px 18px;}
  .mps-subnav-page .mps-link{font-size:13px;}
}
@media(max-width:640px){
  .mps-subnav-page{padding:10px 14px 0;gap:4px 14px;}
  .mps-subnav-page .mps-link{font-size:12px;}
}
`;

function useSubNavStyles() {
  useEffect(() => {
    if (document.getElementById("mps-subnav-css")) return;
    const s = document.createElement("style");
    s.id = "mps-subnav-css";
    s.textContent = SUBNAV_CSS;
    document.head.appendChild(s);
  }, []);
}

/** Synthèse / Leaders / Flux — barre sous-nav (header vert ou page Capital) */
export default function MarketPageSubNav({ variant = "header", language = "fr" }) {
  useSubNavStyles();
  const location = useLocation();
  const navigate = useNavigate();
  const pathname = location.pathname || "/";

  if (variant === "header") {
    return (
      <div className="td-navTitles" role="navigation">
        {LINKS.map((link) => (
          <button
            key={link.id}
            type="button"
            className={`td-navTitle ${link.isActive(pathname) ? "active" : ""}`}
            onClick={(e) => {
              e.stopPropagation();
              navigate(link.href);
            }}
          >
            {language === "en" ? link.labelEn : link.labelFr}
          </button>
        ))}
      </div>
    );
  }

  return (
    <nav className="mps-subnav-page" aria-label="Market sections">
      {LINKS.map((link) => (
        <button
          key={link.id}
          type="button"
          className={`mps-link ${link.isActive(pathname) ? "active" : ""}`}
          onClick={() => navigate(link.href)}
        >
          {language === "en" ? link.labelEn : link.labelFr}
        </button>
      ))}
    </nav>
  );
}
